import Constants from 'constants';
import APP from 'app';
const { Utils } = APP,
    { getFromSession, isEmpty, getTotalValues } = Utils;

const _defaultState = {
    reviewJson: {},
    dataValidation: false,
    hotelBookStatus: {},
    confirmHotelBookStatus: {},
    reviewError: '',
    termsAccepted: false,
    totalDiscount: 0,
    voucherCode: '',
    discountFetching: false,
    coinsAmount: 0,
    coinsFetching: false,
    coinsErr: '',
    coinsApplied: 0,
    highlightWords: [],
    loader: false,
    panValidations: {},
    uploadingDocument: {},
    uploadedDocumentLocation: {},
    disableCorporatePanUser: {},
    corporateBillingEntities: {},
    fetchingReviewJson: false,
    tcsRepricingData: {},
    fetchingTcsRepricing: false,
    consentOps: { tourPackage: 'false' },
    roomNameConsent: false,
    airBookingDetails: {},
    proceedToReviewClicked: false,
    extraCoinAmount: 0
},

    setSession = (key, value) => {
        sessionStorage.setItem(key, JSON.stringify(value));
    },
    setStoreJson = (payload = [], prevStatePayload = []) => {
        const storeJsonStorage = getFromSession([], 'storeJson');
        const arr = !isEmpty(prevStatePayload) ? prevStatePayload : storeJsonStorage
        if (!isEmpty(arr)) {
            const storeJson = arr.map((prevData, prevDataIndex) => {
                const { id = "", travellerInfo = [] } = prevData;
                const travInfo = travellerInfo.map((travData, travIndex) => {
                    const { travellerInfo = [] } = payload[prevDataIndex] || {}
                    const { ed = 0, pt = "" } = travellerInfo[travIndex] || {}
                    return { ti: pt === 'ADULT' ? 'Mr' : 'Master', ...travData, ed }
                })
                return { travellerInfo: travInfo, id }
            })
            return storeJson
        }
        else {
            return payload
        }
    },

    checkout = (state = _defaultState, action) => {
        try {
            const { type, payload } = action;
            switch (type) {
                case Constants.actions.CHECKOUT.FETCHING_REVIEW_JSON: {
                    return {
                        ...state,
                        fetchingReviewJson: true
                    }
                }
                case Constants.actions.CHECKOUT.REVIEW_JSON: {
                    const prevState = state
                    const { status = {}, errors = [], priceValidation = false } = payload,
                        { success } = status,
                        [firstErr = {}] = errors,
                        { message = '' } = firstErr;
                    const finalPayload = {
                        ...payload, storeJson: setStoreJson(payload.storeJson, prevState.reviewJson.storeJson),
                        contactInfo: prevState.reviewJson.contactInfo ? prevState.reviewJson.contactInfo : payload.contactInfo,
                        samePanPerBooking: prevState.reviewJson.samePanPerBooking ? prevState.reviewJson.samePanPerBooking : payload.samePanPerBooking,
                        samePanPerRoom: prevState.reviewJson.samePanPerRoom ? prevState.reviewJson.samePanPerRoom : payload.samePanPerRoom,
                        corporateBookings: prevState.reviewJson.corporateBookings ? prevState.reviewJson.corporateBookings : payload.corporateBookings,
                    }
                    return {
                        ...state,
                        reviewJson: finalPayload,
                        reviewError: !success ? message : '',
                        fetchingReviewJson: false
                    };
                }
                case Constants.actions.CHECKOUT.MODIFY_STORE: {
                    const { reviewJson = {} } = state;
                    const prevState = state,
                        { value = '', room = 0, ref = '', pos = 0, key = '', singleKey = '' } = payload,
                        updatedJson = singleKey ?
                            {
                                ...state,
                                reviewJson: {
                                    ...prevState.reviewJson,
                                    ...prevState.reviewJson[singleKey] = {
                                        ...prevState.reviewJson[singleKey],
                                        [singleKey]: value
                                    }
                                }
                            }
                            :
                            key ? {
                                ...state,
                                reviewJson: {
                                    ...prevState.reviewJson,
                                    ...prevState.reviewJson[key] = {
                                        ...prevState.reviewJson[key],
                                        [ref]: value
                                    }
                                },
                            } : {
                                    ...state,
                                    reviewJson: {
                                        ...state.reviewJson,
                                        ...prevState.reviewJson.storeJson[room].travellerInfo[pos] = {
                                            ...prevState.reviewJson.storeJson[room].travellerInfo[pos],
                                            [ref]: value
                                        }
                                    }
                                };
                    // Added this as temporary. Since above updatedJson is not working in  https://st-agent.tripmaza.com/
                    if (key) {
                        const _temp = reviewJson[key] || {};
                        return {
                            ...state,
                            reviewJson: {
                                ...reviewJson,
                                [key]: {
                                    ..._temp,
                                    [ref]: value
                                }
                            }
                        }
                    }
                    // Till here
                    return updatedJson;
                }
                case Constants.actions.CHECKOUT.VALIDATE: {
                    const { val, contactVal, flag, contactFlag, gstVal, gstFlag, panFlag, panValidations, corporateBookings = false, samePanPerBooking = false, samePanPerRoom = {}, corpBillingEntity = {}, billingEntityFlag = false } = payload;
                    setSession('storeJson', val);
                    setSession('corporateBookings', corporateBookings);
                    setSession('contactInfo', contactVal);
                    setSession('gstInfo', gstVal);
                    setSession('samePanPerBooking', samePanPerBooking);
                    setSession('samePanPerRoom', samePanPerRoom);
                    setSession('BillingEntity', corpBillingEntity);
                    return {
                        ...state,
                        reviewJson: {
                            ...state.reviewJson,
                            storeJson: val,
                            contactInfo: contactVal,
                            gstInfo: gstVal,
                            corporateBookings,
                            samePanPerBooking,
                            samePanPerRoom,
                            BillingEntity: corpBillingEntity
                        },
                        dataValidation: flag && contactFlag && gstFlag && panFlag && billingEntityFlag,
                        panValidations,
                        loader: false,
                        proceedToReviewClicked: true
                    };
                }
                case Constants.actions.CHECKOUT.REVIEW_ACTIVE: {
                    return {
                        ...state,
                        reviewJson: {
                            ...state.reviewJson,
                            activeTab: {
                                ...state.reviewJson.activeTab,
                                ...payload
                            }
                        }
                    };
                }
                case Constants.actions.CHECKOUT.HOTEL_BOOK: {
                    return {
                        ...state,
                        hotelBookStatus: payload
                    };
                }
                case Constants.actions.CHECKOUT.CONFIRM_BOOK: {
                    return {
                        ...state,
                        confirmHotelBookStatus: payload
                    };
                }
                case Constants.actions.CHECKOUT.EMPTY_REVIEW_JSON: {
                    return {
                        ...state,
                        reviewJson: payload
                    };
                }
                case Constants.actions.CHECKOUT.TOGGLE_ACCEPT_TERMS: {
                    return {
                        ...state,
                        termsAccepted: !state.termsAccepted
                    }
                }
                case Constants.actions.CHECKOUT.TOGGLE_TCS_OPTION: {
                    return {
                        ...state,
                        consentOps: payload
                    }
                }
                case Constants.actions.CHECKOUT.UPDATE_CHECKOUT_JSON: {
                    return {
                        ...state,
                        reviewJson: payload
                    }
                }
                case Constants.actions.CHECKOUT.APPLY_VOUCHER: {
                    return {
                        ...state,
                        totalDiscount: action.payload,
                        discountFetching: false
                    }
                }
                case Constants.actions.CHECKOUT.VOUCHER_CODE: {
                    return {
                        ...state,
                        voucherCode: action.payload
                    }
                }
                case Constants.actions.CHECKOUT.VOUCHER_CODE_FETCHING: {
                    return {
                        ...state,
                        discountFetching: true
                    }
                }
                case Constants.actions.CHECKOUT.REMOVE_CODE: {
                    return {
                        ...state,
                        voucherCode: '',
                        totalDiscount: 0
                    }
                }

                case Constants.actions.CHECKOUT.APPLY_COINS_SUCCESS: {
                    const { extraAmount = 0, amount = 0 } = payload
                    return {
                        ...state,
                        coinsAmount: amount,
                        coinsFetching: false,
                        coinsErr: '',
                        extraCoinAmount: extraAmount
                    }
                }
                case Constants.actions.CHECKOUT.COINS_BALANCE: {
                    const coinsApplied = action.payload;
                    return coinsApplied === '' ? {
                        ...state,
                        coinsApplied: 0,
                        coinsAmount: 0,
                        coinsErr: '',
                        extraCoinAmount: 0
                    } : {
                            ...state,
                            coinsApplied
                        }
                }
                case Constants.actions.CHECKOUT.COINS_BALANCE_FETCHING: {
                    return {
                        ...state,
                        coinsFetching: true
                    }
                }
                case Constants.actions.CHECKOUT.APPLY_COINS_FAILURE: {
                    return {
                        ...state,
                        coinsAmount: 0,
                        coinsFetching: false,
                        coinsErr: payload,
                        extraCoinAmount: 0
                    }
                }
                case Constants.actions.CHECKOUT.BOOKING_NOTES_HIGHLIGHT: {
                    return {
                        ...state,
                        highlightWords: payload
                    };
                }
                case Constants.actions.CHECKOUT.DISABLE_CORPORATE_PAN: {
                    return {
                        ...state,
                        disableCorporatePanUser: payload
                    };
                }
                case Constants.actions.CHECKOUT.GET_CORPORATE_GST_INFO: {
                    return {
                        ...state,
                        corporateBillingEntities: payload
                    };
                }
                case Constants.actions.CHECKOUT.BUTTON_LOADER: {
                    return {
                        ...state,
                        loader: true
                    };
                }
                case Constants.actions.CHECKOUT.UPLOADED_DOCUMENT_LOCATION: {
                    const { reference = '', uploadedDocumentLocation: location = [] } = payload;
                    return {
                        ...state,
                        uploadedDocumentLocation: {
                            ...state.uploadedDocumentLocation,
                            [reference]: location
                        },
                        uploadingDocument: {
                            [reference]: false
                        }
                    };
                }
                case Constants.actions.CHECKOUT.UPLOADED_DOCUMENT_UPLOADING: {
                    const { reference = '' } = payload;
                    return {
                        ...state,
                        uploadingDocument: {
                            [reference]: true
                        }
                    };
                }
                case Constants.actions.CHECKOUT.FETCH_TCSPRICINGDATA: {
                    return {
                        ...state,
                        reviewJson: {
                            ...state.reviewJson,
                            fetchingTcsRepricing: true
                        }

                    }
                };

                case Constants.actions.CHECKOUT.GET_TCSPRICINGDATA: {
                    const { rti = [], hi = {}, roomLevelEdArray = [], bookingLevelEd = "" } = payload
                    const { ops = [], ss = [] } = hi
                    const [firstObj = {}] = ops,
                        { omi = {} } = firstObj,
                        { ispfar = false } = omi;
                    const { ris = [] } = firstObj
                    return {
                        ...state,
                        reviewJson: {
                            ...state.reviewJson,
                            storeJson: rti,
                            ispfar: ispfar,
                            bookingLevelEd,
                            roomLevelEdArray,
                            totalValues: getTotalValues(ris, ss, omi),
                            tcsRepricingData: payload,
                            samePanPerBooking: ispfar,
                            fetchingTcsRepricing: false
                        },

                    };
                };
                case Constants.actions.CHECKOUT.TOGGLE_ROOM_CONSENT: {
                    return {
                        ...state,
                        roomNameConsent: !state.roomNameConsent
                    }
                }
                case Constants.actions.CHECKOUT.TOGGLE_CORPORATE_TCS: {
                    return {
                        ...state,
                        reviewJson: {
                            ...state.reviewJson,
                            isTcsApplicable: payload
                        }
                    }
                }
                case Constants.actions.CHECKOUT.AIR_BOOK: {
                    return {
                        ...state,
                        airBookingDetails: payload
                    }
                }
                case Constants.actions.CHECKOUT.REVIEW_CLICKED: {
                    return {
                        ...state,
                        proceedToReviewClicked: false
                    }
                }
                default:
                    return state;
            }
        } catch (error) {
            console.log("checkout reducer try catch error:: ", error);
            return _defaultState;
        }
    };

export default checkout;
